export default {
    host: '0.0.0.0',
    apiBaseUrl: 'http://localhost:8080/',
    apiFeBaseUrl: 'http://localhost:8080/',
    siteBaseUrl: '',
};
